// extracted by mini-css-extract-plugin
module.exports = {"saved-list-table__header-cell":"saved-list-table_saved-list-table__header-cell__yNocs"};